module.exports = __webpack_public_path__ + "img/bus-warbe-plus.f19e70d0.png";